var map = {
	"./agiliza/background.svg": "0b4c",
	"./ancora/background.svg": "9bde",
	"./autobanking/background.svg": "7591",
	"./gente/background.svg": "2ca4",
	"./girocred/background.svg": "0053",
	"./ideal_veiculos/background.svg": "d74f",
	"./lucash/background.svg": "8ba9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "98e1";